"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreClient = exports.standardRetryPolicy = exports.givzDeviceIdKey = void 0;
var tslib_1 = require("tslib");
var uuid_1 = require("uuid");
var _rest_client_1 = require("../rest-client/index");
var utils_1 = require("./utils");
exports.givzDeviceIdKey = 'givz_device_id';
exports.standardRetryPolicy = {
    delay: 500,
    exponential: true,
    maxAttempts: 5,
};
var CoreClient = function (basePath, clientVersion, configuration, axios, deviceId) {
    var _a;
    var _b;
    deviceId = deviceId || (0, uuid_1.v4)();
    var coreClientVersion = '0.2.60';
    var isPackageVersion = /^\d+\.\d+\.\d+$/.test(coreClientVersion);
    if (!isPackageVersion) {
        throw new Error("Not a valid package version: ".concat(coreClientVersion));
    }
    var innerConfig = tslib_1.__assign(tslib_1.__assign({}, configuration), { baseOptions: tslib_1.__assign(tslib_1.__assign({}, configuration === null || configuration === void 0 ? void 0 : configuration.baseOptions), { headers: tslib_1.__assign(tslib_1.__assign({}, (_b = configuration === null || configuration === void 0 ? void 0 : configuration.baseOptions) === null || _b === void 0 ? void 0 : _b.headers), (_a = {}, _a[exports.givzDeviceIdKey] = deviceId, _a['X-Givz-Agent'] = "core-client/".concat(coreClientVersion).concat(clientVersion ? " (".concat(clientVersion, ")") : ''), _a)) }) });
    var accountsApi = new _rest_client_1.AccountsApi(innerConfig, basePath, axios);
    var adminApi = new _rest_client_1.AdminApi(innerConfig, basePath, axios);
    var authApi = new _rest_client_1.AuthApi(innerConfig, basePath, axios);
    var campaignsApi = new _rest_client_1.CampaignsApi(innerConfig, basePath, axios);
    var categoriesApi = new _rest_client_1.CategoriesApi(innerConfig, basePath, axios);
    var collectionsApi = new _rest_client_1.CollectionsApi(innerConfig, basePath, axios);
    var consumerApi = new _rest_client_1.ConsumerApi(innerConfig, basePath, axios);
    var couponCodesApi = new _rest_client_1.CouponCodesApi(innerConfig, basePath, axios);
    var donationCreditsApi = new _rest_client_1.DonationCreditsApi(innerConfig, basePath, axios);
    var donationsApi = new _rest_client_1.DonationsApi(innerConfig, basePath, axios);
    var featuresApi = new _rest_client_1.FeaturesApi(innerConfig, basePath, axios);
    var fileUploadsApi = new _rest_client_1.FileUploadsApi(innerConfig, basePath, axios);
    var freeTrialsApi = new _rest_client_1.FreeTrialsApi(innerConfig, basePath, axios);
    var hostedApi = new _rest_client_1.HostedApi(innerConfig, basePath, axios);
    var impersonatorApi = new _rest_client_1.ImpersonatorApi(innerConfig, basePath, axios);
    var integrationsApi = new _rest_client_1.IntegrationsApi(innerConfig, basePath, axios);
    var invoicesApi = new _rest_client_1.InvoicesApi(innerConfig, basePath, axios);
    var ordersApi = new _rest_client_1.OrdersApi(innerConfig, basePath, axios);
    var organizationApi = new _rest_client_1.OrganizationsApi(innerConfig, basePath, axios);
    var previewApi = new _rest_client_1.PreviewApi(innerConfig, basePath, axios);
    var reportsApi = new _rest_client_1.ReportsApi(innerConfig, basePath, axios);
    var shopifyApi = new _rest_client_1.ShopifyApi(innerConfig, basePath, axios);
    var subscriptionsApi = new _rest_client_1.SubscriptionsApi(innerConfig, basePath, axios);
    var trackApi = new _rest_client_1.TrackApi(innerConfig, basePath, axios);
    var widgetApi = new _rest_client_1.WidgetApi(innerConfig, basePath, axios);
    return {
        Accounts: {
            getCurrent: (0, utils_1.invoke)(accountsApi, 'accountsControllerGetCurrentAccount'),
            getCurrentShopifyAppReview: (0, utils_1.invoke)(accountsApi, 'accountsControllerGetCurrentShopifyAppReview'),
            getCurrentUsage: (0, utils_1.invoke)(accountsApi, 'accountsControllerGetCurrentUsage'),
            updateCurrent: (0, utils_1.invoke)(accountsApi, 'accountsControllerUpdateCurrentAccount'),
        },
        Admin: {
            Organizations: {
                create: (0, utils_1.invoke)(adminApi, 'adminOrganizationsControllerCreateOrganization'),
                search: (0, utils_1.invoke)(adminApi, 'adminOrganizationsControllerSearchOrganizations'),
                update: (0, utils_1.invoke)(adminApi, 'adminOrganizationsControllerUpdateOrganization'),
            },
        },
        Auth: {
            changePassword: (0, utils_1.invoke)(authApi, 'authControllerChangePassword'),
            forgotPassword: (0, utils_1.invoke)(authApi, 'authControllerForgotPassword'),
            login: (0, utils_1.invoke)(authApi, 'authControllerLogin'),
            resetPassword: (0, utils_1.invoke)(authApi, 'authControllerResetPassword'),
            signup: (0, utils_1.invoke)(authApi, 'authControllerSignup'),
        },
        Campaigns: {
            activate: (0, utils_1.invoke)(campaignsApi, 'campaignsControllerActivateCampaign'),
            archive: (0, utils_1.invoke)(campaignsApi, 'campaignsControllerArchiveCampaign'),
            changePriority: (0, utils_1.invoke)(campaignsApi, 'campaignsControllerChangeCampaignPriority'),
            create: (0, utils_1.invoke)(campaignsApi, 'campaignsControllerCreateCampaign'),
            deactivate: (0, utils_1.invoke)(campaignsApi, 'campaignsControllerDeactivateCampaign'),
            getShopifyPrePurchasePromotionPreviewLinks: (0, utils_1.invoke)(campaignsApi, 'campaignsControllerGetShopifyPrePurchasePromotionPreviewLinks'),
            getAll: (0, utils_1.invoke)(campaignsApi, 'campaignsControllerGetAllCampaigns'),
            unarchive: (0, utils_1.invoke)(campaignsApi, 'campaignsControllerUnarchiveCampaign'),
            update: (0, utils_1.invoke)(campaignsApi, 'campaignsControllerUpdateCampaign'),
        },
        Categories: {
            getAll: (0, utils_1.invoke)(categoriesApi, 'categoriesControllerGetAll'),
        },
        Collections: {
            get: (0, utils_1.invoke)(collectionsApi, 'collectionsControllerGetCollection'),
            getCurated: (0, utils_1.invoke)(collectionsApi, 'collectionsControllerGetCuratedCollection'),
            createHandpicked: (0, utils_1.invoke)(collectionsApi, 'collectionsControllerCreateHandpickedCollection'),
            updateHandpicked: (0, utils_1.invoke)(collectionsApi, 'collectionsControllerUpdateHandpickedCollection'),
        },
        Consumer: {
            unsubscribe: (0, utils_1.invoke)(consumerApi, 'consumerControllerUnsubscribe'),
        },
        CouponCodes: {
            search: (0, utils_1.invoke)(couponCodesApi, 'couponCodesControllerSearchCouponCodes'),
        },
        DonationCredits: {
            create: (0, utils_1.invoke)(donationCreditsApi, 'donationCreditsControllerCreateDonationCredit'),
            getPreviewToken: (0, utils_1.invoke)(donationCreditsApi, 'donationCreditsControllerGetPreviewDonationCredit'),
            getFromToken: (0, utils_1.invoke)(donationCreditsApi, 'donationCreditsControllerGetDonationCreditFromToken'),
        },
        Donations: {
            create: (0, utils_1.invoke)(donationsApi, 'donationsControllerCreateDonation'),
            export: (0, utils_1.invoke)(donationsApi, 'donationsControllerExportDonations'),
            get: (0, utils_1.invoke)(donationsApi, 'donationsControllerGetDonationFromGid'),
            search: (0, utils_1.invoke)(donationsApi, 'donationsControllerSearchDonations'),
            share: (0, utils_1.invoke)(donationsApi, 'donationsControllerShareDonation'),
            void: (0, utils_1.invoke)(donationsApi, 'donationsControllerVoidDonation'),
        },
        Features: {
            getAll: (0, utils_1.invoke)(featuresApi, 'featuresControllerGetAllFeatures'),
        },
        FileUploads: {
            createUploadSignature: (0, utils_1.invoke)(fileUploadsApi, 'fileUploadsControllerGetUploadRequestSignature'),
        },
        FreeTrials: {
            get: (0, utils_1.invoke)(freeTrialsApi, 'freeTrialsControllerGetFreeTrial'),
        },
        Hosted: {
            campaigns: {
                activate: (0, utils_1.invoke)(hostedApi, 'hostedCampaignsControllerActivateCampaign'),
                deactivate: (0, utils_1.invoke)(hostedApi, 'hostedCampaignsControllerDeactivateCampaign'),
                duplicate: (0, utils_1.invoke)(hostedApi, 'hostedCampaignsControllerDuplicateCampaign'),
                generator: (0, utils_1.invoke)(hostedApi, 'hostedCampaignsControllerCampaignGenerator'),
                getAll: (0, utils_1.invoke)(hostedApi, 'hostedCampaignsControllerGetCampaigns'),
                get: (0, utils_1.invoke)(hostedApi, 'hostedCampaignsControllerGetCampaign'),
                overview: (0, utils_1.invoke)(hostedApi, 'hostedCampaignsControllerOverview'),
                update: (0, utils_1.invoke)(hostedApi, 'hostedCampaignsControllerUpdateCampaign'),
            },
        },
        Impersonator: {
            listAccounts: (0, utils_1.invoke)(impersonatorApi, 'impersonatorControllerGetAccounts'),
            impersonate: (0, utils_1.invoke)(impersonatorApi, 'impersonatorControllerImpersonate'),
        },
        Integrations: {
            createAttentive: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerCreateAttentiveIntegration'),
            createKlaviyo: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerCreateKlaviyoIntegration'),
            createPostscript: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerCreatePostscriptIntegration'),
            deleteAttentive: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerDeleteAttentiveIntegration'),
            deleteKlaviyo: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerDeleteKlaviyoIntegration'),
            deletePostscript: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerDeletePostscriptIntegration'),
            search: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerGetIntegrations'),
            syncKlaviyoEvents: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerSyncKlaviyoEvents'),
            syncAttentiveSubscriberAttributes: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerSyncAttentiveSubscriberAttributes'),
            syncPostscriptSubscriberAttributes: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerSyncPostscriptSubscriberAttributes'),
            syncShopifyMetadata: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerSyncShopifyMetadata'),
            update: (0, utils_1.invoke)(integrationsApi, 'integrationsControllerUpdateIntegrations'),
        },
        Invoices: {
            search: (0, utils_1.invoke)(invoicesApi, 'invoicesControllerSearchInvoices'),
        },
        Orders: {
            export: (0, utils_1.invoke)(ordersApi, 'ordersControllerExportOrders'),
            search: (0, utils_1.invoke)(ordersApi, 'ordersControllerSearchOrders'),
        },
        Organizations: {
            get: (0, utils_1.invoke)(organizationApi, 'organizationsControllerGetOrganization'),
            search: (0, utils_1.invoke)(organizationApi, 'organizationsControllerSearchOrganizations'),
        },
        Preview: {
            previewShopifyOrder: (0, utils_1.invoke)(previewApi, 'previewControllerPreviewShopifyOrder'),
        },
        Reports: {
            exportOrganizations: (0, utils_1.invoke)(reportsApi, 'reportsControllerExportOrganizationsReport'),
            overview: (0, utils_1.invoke)(reportsApi, 'reportsControllerGetOverviewReport'),
            organizations: (0, utils_1.invoke)(reportsApi, 'reportsControllerGetOrganizationsReport'),
        },
        Shopify: {
            createShopifyAppAccessToken: (0, utils_1.invoke)(shopifyApi, 'shopifyAccessTokensControllerCreateShopifyAppAccessToken'),
            processPreviewShopifyOrder: (0, utils_1.invoke)(shopifyApi, 'processShopifyOrderControllerProcessPreviewShopifyOrder'),
            processShopifyOrder: (0, utils_1.invoke)(shopifyApi, 'processShopifyOrderControllerProcessShopifyOrderFromWidget'),
            processShopifyPage: (0, utils_1.invoke)(shopifyApi, 'processShopifyPageControllerProcessShopifyPage'),
        },
        Subscriptions: {
            cancelPending: (0, utils_1.invoke)(subscriptionsApi, 'subscriptionsControllerCancelPendingSubscription'),
            create: (0, utils_1.invoke)(subscriptionsApi, 'subscriptionsControllerCreateSubscription'),
            search: (0, utils_1.invoke)(subscriptionsApi, 'subscriptionsControllerSearchSubscriptions'),
            Packages: {
                search: (0, utils_1.invoke)(subscriptionsApi, 'subscriptionPackagesControllerGetAllSubscriptionPackages'),
            },
        },
        Track: {
            device: (0, utils_1.invoke)(trackApi, 'trackControllerTrackDevice'),
        },
        Widget: {
            getShopifyPrePurchase: (0, utils_1.invoke)(widgetApi, 'widgetControllerGetShopifyPrePurchaseWidget'),
            installShopifyPrePurchase: (0, utils_1.invoke)(widgetApi, 'widgetControllerInstallShopifyPrePurchaseWidget'),
            uninstallShopifyPrePurchase: (0, utils_1.invoke)(widgetApi, 'widgetControllerUninstallShopifyPrePurchaseWidget'),
        },
        getDeviceId: function () { return deviceId; },
    };
};
exports.CoreClient = CoreClient;
//# sourceMappingURL=client.js.map